import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from "recharts";
import React from "react";

class ChartAge extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <ResponsiveContainer width={240} height={240}>
        <PieChart onMouseEnter={this.onPieEnter}>
          <Pie
            data={data}
            dataKey="value"
            cx={"50%"}
            cy={"50%"}
            innerRadius={"40%"}
            outerRadius={"100%"}
            styles={this.styles}
            fill="#8884d8"
          >
            {data.map((entry, index) => {
              return <Cell fill={entry.color} key={index} />;
            })}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    );
  }
}

export default ChartAge;
